module.exports = {
    // default (green), red, yellow, blue
    colorSchema: 'blue',
    urlPath: '/app/',
    appClass: 'orehab',
    footer: require('./footer.html'),
    pageTitle: 'OREHAB MINDS',
    sideMenu: require('./Sidemenu.js'),
    logoSideMenu: '/img/BR-OCS-Logo_Weiss.GIF',
    logo: '/img/BR-OCS-Logo_4C.GIF',
    allowDeliveryPrint: false,
    defaultView: 'Projects',
    orderStatuses: [
      {label: 'Reports.statusAll', value: '', alias: 'all'},
      {label: 'Reports.statusReceived', value: 0, alias: 'received'},
      {label: 'Reports.statusInProgress', value: 1, alias: 'inprogress'},
      {label: 'Reports.statusCancelled', value: 3, alias: 'cancelled'},
      {label: 'Reports.statusCompleted', value: 4, alias: 'completed'}
    ],
    orderStatusCodes: {
      finished: true
    },
    workflowTypes: {
      chew: require('./Chew/Chew.js'),
      brux: require('./Brux/Brux.js'),
      ceph: require('./Ceph/Ceph.js'),
      condy: require('./Condy/Condy.js'),
      addons: require('./Addons/Addons.js')
    },
    projectTypes: {
      chew: require('./Chew/Chew.js'),
      brux: require('./Brux/Brux.js'),
      condy: require('./Condy/Condy.js'),
      ceph: require('./Ceph/Ceph.js')
    },
    projectColumns: [
      'mixed',
      'creationdate',
      'lastmodified',
      'workflow',
      'transactionstatus'
    ],
    orderColumns: [
      'transactionnum',
      'reference',
      'workflow',
      'date',
      'amount',
      'status',
    ],
    loginOutro: {
      de: '<b>Passwort vergessen?</b> <a href="/app/login/reset">Hier zurücksetzen!</a>' + '<br/>' +
        '<b>Noch kein Kunde?</b> <a href="/register/">Hier können Sie sich registrieren!</a>',
      en: '<b>Forgot password?</b> <a href="/app/login/reset">Reset here!</a>' + '<br/>' +
        '<b>No account yet?</b> <a href="/register/">You can register here!</a>',
      es: '<b>¿Olvidó su contraseña?</b> <a href="/app/login/reset">Aquí puede restablecer su contraseña.</a>' + '<br/>' +
        '<b>¿Todavía no es cliente?</b> <a href="/register/">Puede registrarse aquí.</a>',
      fr: '<b>Vous avez oublié votre mot de passe?</b> <a href="/app/login/reset">Ici vous pouvez réinitialiser!</a>' + '<br/>' +
        '<b>Pas encore client?</b> <a href="/register/">Vous pouvez vous enregistrer ici.</a>',
      pt: '<b>Esqueceu a palavra-passe?</b> <a href="/app/login/reset">Aqui poderá repor a sua palavra-passe!</a>' + '<br/>' +
        '<b>Ainda não é cliente?</b> <a href="/register/">Poderá registar-se aqui!</a>',
      it: '<b>Password dimenticata?</b> <a href="/app/login/reset">Qui puoi reimpostare la password!</a>' + '<br/>' +
        '<b>Non sei ancora registrato?</b> <a href="/register/">Puoi registrarti qui!</a>',
      ru: '<b>Забыли пароль?</b> <a href="/app/login/reset">Здесь можно сбросить пароль!</a>' + '<br/>' +
        '<b>Еще не клиент?</b> <a href="/register/">Здесь можно зарегистрироваться!</a>'
    },
    disableInvoiceList: true,
    disableAddressEdit: false,
    disableAddressSelect: false,
    disablePasswordChange: true,
    disableHeaderNofications: true,
    disableMessages: true,
    locales: {
      de: require('./Locale/de.js'),
      en: require('./Locale/en.js'),
      es: require('./Locale/es.js'),
      fr: require('./Locale/fr.js'),
      pt: require('./Locale/pt.js'),
      it: require('./Locale/it.js'),
      ru: require('./Locale/ru.js')
    },
    hintNewProject: {
      en: 'Please make sure that patient-related data is stored anonymously! By creating a new project you accept our <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">privacy policy</a>.',
      de: 'Bitte stellen Sie sicher, dass patientenbezogene Daten anonymisiert hinterlegt werden! Durch Anlegen eines neuen Projekts akzeptieren Sie unsere <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Datenschutzhinweise</a>.',
      es: 'Por favor, asegúrese de que los datos relacionados con el paciente se almacenan de forma anónima. Al crear un nuevo proyecto, usted acepta nuestra <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Política de Privacidad</a>.',
      fr: 'Veuillez-vous assurer que les données se rapportant au patient soient fournies sous forme anonymisée! En créant un nouveau projet, vous acceptez nos <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">principes de protection des données</a>.',
      pt: 'Assegure-se que as informações relacionadas com a proteção de dados são guardadas em confidencialidade! Ao introduzir um novo projeto está a aceitar a nossa <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">política de privacidade</a>.',
      it: 'Assicurarsi che i dati relativi al paziente siano stati memorizzati in modo anonimo! Creando un nuovo progetto Lei accetta la nostra informativa sulla protezione dei <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">dati personali</a>.',
      ru: 'Помните о том, что персональные данные пациента должны быть скрыты! Создавая новый проект, вы принимаете наши <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Положения по защите данных</a>.'
    },
    infothek: require('./Infothek.html')
}
